// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
export const AUTHORIZATION = 'AUTHORIZATION'
export const TENANT = 'AUTHORIZATION_MSP_MANAGED'

export const policyTypeEnum = Object.freeze({
  DOMAIN_LEGACY: 'Legacy domain',
  DOMAIN_VERIFIED: 'Verified domain',
  DOMAIN_EXTERNAL: 'External domain',
  USER_RECOVERY: 'Users'
})

/**
 * Categories:
 *
 * These constants represent the possible categories under which services can be organized.
 */
export const CATEGORY = {
  MANAGEMENT_AND_GOVERNANCE: 'MANAGEMENT_AND_GOVERNANCE',
  MGMT_GOV: 'MGMT_GOV',
  COMPUTE: 'COMPUTE',
  NETWORKING: 'NETWORKING',
  PRIVATE_CLOUD: 'PRIVATE_CLOUD',
  STORAGE: 'STORAGE',
  WORKLOADS: 'WORKLOADS',
  COMMON: 'COMMON',
  RECOMMENDED: 'RECOMMENDED',
  ORIGANIZATION: 'ORIGANIZATION',
  AI_ML_ANALYTICS: 'AI_ML_ANALYTICS'
}

export const authorizationModeEnum = Object.freeze({
  AUTHENTICATION_ONLY_MODE: 'Local role assignments',
  AUTHORIZATION_MODE: 'SSO role assignments'
})

export const mspApplicationEnum = Object.freeze({
  ORG_WORKSPACES: 'Applies to the MSP organization',
  MANAGED_ORGANIZATIONS: 'Applies to all customer organizations'
})

export const ssoConnectionTypeEnum = Object.freeze({
  EXTERNAL: 'External',
  SSO_PROFILE: 'SSO Profile'
})
